import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'CCI',
  version: 2,
  label: 'Commodity Channel Index',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 40,
  inputs: [period('timeperiod', 14)],
  outputs: [line('cci', 'CCI', COLOR.blue)],
  levels: [{ value: 100 }, { value: -100 }],
  talib: { functions: ['CCI'], expr: 'CCI(high, low, close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
